import { call, put, takeEvery } from "redux-saga/effects";
import {  toast } from 'react-toastify';
import {GET_LOGIN_SUCCESS, GET_LOGIN_FAILED, GET_LOGIN_REQUESTED} from "resources/actionTypes";
import { loginApi } from "services/LoginService";
import 'react-toastify/dist/ReactToastify.css';

function* fetchLogin(action) {
  const payload = action.payload || {};
  const userLogin = yield call(loginApi,payload?.userLoginPayload?.userDetails);
  if(userLogin?.success){
    yield put({ type: GET_LOGIN_SUCCESS, userLogin: userLogin });
  
    if(payload?.userLoginPayload?.actionType === "login") {
      payload?.setOnOtp(true);

      const userDetails = {
        mobile: payload?.userLoginPayload?.userDetails?.mobileOrEmail,
        code: payload?.userLoginPayload?.userDetails?.countryCode,
        secretToken: userLogin.data[0].otpSecret
      }
      localStorage.setItem('loginDetails', JSON.stringify(userDetails));
    }
    toast.success(userLogin?.message);
  }else{
    yield put({ type: GET_LOGIN_FAILED, message: userLogin?.message });
      toast.error(userLogin?.message || 'Login failed'); 
  }
}
function* loginSaga() {
  yield takeEvery(GET_LOGIN_REQUESTED, fetchLogin);

}

export default loginSaga;
